//  import { cloneDeep } from 'lodash'

//  import { v4 as uuidv4 } from 'uuid'//未装，npm install uuid

/**
 * @description 获取不重复的id
 * @param {number} [length] - id的长度
 * @return {string} id
 */
/* export function getUuid (length) {
    const uuid = uuidv4()
    if (length) {
        return uuid.replace(/-/g, '').substring(0, length)
    }
    return uuid
} */

/**
 * @description 将二维数组中的指定字段设置为空，用于重置selected选中状态
 * @param {Array} arr - 二维数组
 * @param {string} field - 要清空的字段
 * @param {*} value - 要设置的值
 */
export function clearField (arr, field, value) {
    //  console.log('==fun==clearField==',arr)
    arr.forEach(row => {
        //  console.log('==fun==clearField=row=',row)
        row[field] = value
       /*  row.forEach(item => {
            item[field] = value
        }) */
    })
}

/**
 * @description 获取选中的项
 * @param {Array} arr
 * @param {string} field
 * @returns {object}
 */
export function getSelectedItem (arr) {
    //  console.log('==fun==clearField==',arr)
    let obj = {}
    if (arr.length > 0) {
        arr.forEach(row => {
            //  console.log('==fun==clearField=row=',row)
            if (row['selected'] === 'selected') {
                obj = row
                return obj
            }
        })
    }
    return obj
}

/**
 * @description 获取不重复的id
 * @param length { Number } id的长度
 * @return { String } id
 */
export function getNonDuplicateID (length = 8) {
    let idStr = Date.now().toString(36)
    idStr += Math.random().toString(36).substring(3, length)
    return idStr
}

/**
 * @description 把子级分类放入父级分类中
 * @param { array } pidIdAry
 * @returns { array }
 */
export function getMapWithPidId (pidIdAry) {
    let map = []
    for (let key in pidIdAry) {
        if (!map[pidIdAry[key]['pid']]) {
            map[pidIdAry[key]['pid']] = []
        }
        if (map[pidIdAry[key]['pid']]) {
            map[pidIdAry[key]['pid']].push(pidIdAry[key])
        }
    }
    return map
}

/**
 * 计算年龄
 * @param {*} date
 */
export function calculateAge (date) {
    if (date) {
      const selectedDate = new Date(date)
      const today = new Date()
      // 计算年差和月差
      let years = today.getFullYear() - selectedDate.getFullYear()
      let months = today.getMonth() - selectedDate.getMonth()
      // 如果当月还没到生日月，或当天没到生日天，则年份减少，月份加12
      if (months < 0 || (months === 0 && today.getDate() < selectedDate.getDate())) {
        years--
        months += 12
      }
      // 计算月差，如果今天的日期小于出生日期，则月份减少
      if (today.getDate() < selectedDate.getDate()) {
        months--
      }
      return `${years}岁${months}月`
    } else {
      return ''
    }
  }
/**
 * 返回时间格式
 * @param {*} date
 * @returns
 */
  export function formatDate (date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }



// WEBPACK FOOTER //
// ./src/utils/util.js